// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module--link--bExD8","aboutBetter":"styles-module--aboutBetter--1BoEu"};